import { render, staticRenderFns } from "./CommandeTable.vue?vue&type=template&id=3eca174e&scoped=true"
import script from "./CommandeTable.vue?vue&type=script&lang=js"
export * from "./CommandeTable.vue?vue&type=script&lang=js"
import style0 from "./CommandeTable.vue?vue&type=style&index=0&id=3eca174e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca174e",
  null
  
)

export default component.exports